var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"fixed":""}},[_c('span',[_vm._v("\n    © 2019 Guang Yang\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }